import { useContext } from 'react';
import { InternalLayoutContext } from '../Layouts/InternalLayoutProvider';
import { MPFIconButton } from 'volto-ministerio-publico-federal/components/UI';
import {
  usePrintPage,
  useSharePage,
} from 'volto-ministerio-publico-federal/hooks';
import {
  StateRule,
  useWorkflowState,
} from 'volto-ministerio-publico-federal/components/WorkflowState';
import { PrinterIcon, ShareFatIcon } from '@phosphor-icons/react';

export const PageTitle = () => {
  const { title, description, ocultarTitulo, reviewState } = useContext(
    InternalLayoutContext,
  );
  const workflowState = useWorkflowState(reviewState);
  const handlePrint = usePrintPage();
  const handleShare = useSharePage(title);

  return (
    <>
      <header
        className="mpf-internal-view__header"
        style={workflowState ? { borderBottomWidth: 0 } : undefined}
      >
        <div className="mpf-internal-view__header-and-description">
          {/* Com "Ocultar título" o `h1` sai da tela, mas fica para leitores de
            tela: sem ele a árvore de headings começaria no `h2` do primeiro
            bloco (mesmo recurso da sub-home, em `SubHomeLayout`). */}
          {title && (
            <h1
              className={ocultarTitulo ? 'sr-only' : 'mpf-internal-view__title'}
            >
              {title}
            </h1>
          )}
          {description && (
            <p className="mpf-internal-view__description">{description}</p>
          )}
        </div>
        <div className="mpf-internal-view__actions">
          <MPFIconButton
            size="xl"
            icon={<PrinterIcon />}
            shape="square"
            variant="ghost"
            aria-label="Imprimir"
            onClick={handlePrint}
          />
          <MPFIconButton
            size="xl"
            icon={<ShareFatIcon />}
            shape="square"
            variant="ghost"
            aria-label="Compartilhar"
            onClick={handleShare}
          />
        </div>
      </header>
      {workflowState && (
        <div className="mpf-internal-view__state">
          <StateRule info={workflowState} />
        </div>
      )}
    </>
  );
};
